import React from 'react';
import { motion } from 'framer-motion';

const GameMessage = ({ message, gameOver }) => {
  if (!message) return null;
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      style={{
        margin: "15px 0",
        padding: "10px",
        backgroundColor: gameOver ? "#F8D7DA" : "#D4EDDA",
        borderRadius: "5px",
        color: gameOver ? "#721C24" : "#155724"
      }}
    >
      {message}
    </motion.div>
  );
};

export default GameMessage;
